<script lang="ts">
  /**
   * "Insert template" menu (spec §11): `noTemplates` or one row per `store.templates` entry
   * (name → insert, × → `store.removeTemplate`). Arrow keys cycle the items, Tab is trapped,
   * Escape closes.
   */
  import { t } from '$lib/i18n';
  import { store } from '$lib/store';
  import { focusTrap, menuKeys, tooltip } from '$lib/util/dom';

  let { id, onpick, onclose }: { id: string; onpick: (body: string) => void; onclose: () => void } = $props();

  function onKey(ev: KeyboardEvent): void {
    if (ev.key !== 'Escape') return;
    ev.preventDefault();
    ev.stopPropagation();
    onclose();
  }
</script>

<div class="tpl-menu" role="menu" tabindex="-1" {id} use:menuKeys use:focusTrap onkeydown={onKey}>
  {#if store.templates.length}
    {#each store.templates as tpl (tpl.id)}
      <div class="tpl-row">
        <button type="button" class="tpl-opt" role="menuitem" data-id={tpl.id} onclick={() => onpick(tpl.body)}>{tpl.name}</button>
        <button type="button" class="tpl-del" aria-label={`${t('del')} ${tpl.name}`} use:tooltip onclick={() => void store.removeTemplate(tpl.id)}>×</button>
      </div>
    {/each}
  {:else}
    <p class="tpl-empty">{t('noTemplates')}</p>
  {/if}
</div>

<style>
  /* ===== component: svelte-lveo7m (Compose) — template menu rules ===== */
  .tpl-menu {
    position: absolute;
    inset-block-start: var(--space-1);
    inset-inline: var(--space-3);
    z-index: var(--z-layer);
    border: 1px solid var(--border-default);
    border-radius: var(--radius-md);
    background: var(--surface-card);
    box-shadow: var(--shadow-md);
    max-height: 220px;
    overflow: auto;
  }

  .tpl-row {
    display: flex;
    align-items: center;
  }

  .tpl-opt {
    flex: 1;
    text-align: start;
    border: 0;
    background: none;
    color: var(--text-body);
    padding: var(--space-3) var(--space-4);
    font: inherit;
    cursor: pointer;
  }

  .tpl-opt:hover {
    background: var(--surface-subtle);
  }

  .tpl-opt:active {
    background: var(--surface-sunken);
  }

  .tpl-del {
    border: 0;
    background: none;
    color: var(--text-muted);
    cursor: pointer;
    padding: 0 var(--space-3);
    font-size: var(--text-lg);
  }

  .tpl-empty {
    color: var(--text-muted);
    padding: var(--space-3) var(--space-4);
    font-size: var(--text-sm);
  }
</style>
